import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="flex items-center justify-center h-screen">
      <div className="text-center">
        <h1 className="text-4xl font-bold mb-4 text-blue-500">
          404 - Not Found
        </h1>
        <p className="text-gray-600">
          The page you are looking for might be in another castle.
        </p>
        <Link to="/" className="text-blue-500 hover:underline mt-4 block">
          Go Home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
